module.exports = __webpack_public_path__ + "static/media/pe.ee097e50.svg";